import { __ } from '@wordpress/i18n';
import { BaseControl, ButtonGroup, Button, Tooltip } from '@wordpress/components';
import { desktop, tablet, mobile } from '@wordpress/icons';
// import './style.scss';

const DEVICE_TYPES = {
    DESKTOP: 'desktop',
    TABLET: 'tablet',
    MOBILE: 'mobile'
};

const VisibilityControl = ({ value = {}, onChange, label = __('Cihaz Görünürlüğü', 'kanews') }) => {
    const devices = {
        [DEVICE_TYPES.DESKTOP]: {
            label: __('Masaüstü', 'kanews'),
            icon: desktop,
            hiddenLabel: __('Masaüstünde gizli', 'kanews')
        },
        [DEVICE_TYPES.TABLET]: {
            label: __('Tablet', 'kanews'),
            icon: tablet,
            hiddenLabel: __('Tablette gizli', 'kanews')
        },
        [DEVICE_TYPES.MOBILE]: {
            label: __('Mobil', 'kanews'),
            icon: mobile,
            hiddenLabel: __('Mobilde gizli', 'kanews')
        }
    };

    const toggleDevice = (device) => {
        onChange({
            ...value,
            [device]: !value[device]
        });
    };

    const getHiddenLabel = (device) => {
        return value[device] === false ? devices[device].hiddenLabel : '';
    };

    return (
        <BaseControl
            label={label}
            __nextHasNoMarginBottom={true}
        >
            <div className="kanews-visibility-control kanews-control-item">
                <div className="kanews-visibility-control__devices">
                    {Object.entries(devices).map(([device, { label, icon }]) => (
                        <Tooltip text={label} key={device}>
                            <Button
                                icon={icon}
                                label={label}
                                isPressed={value[device] !== false}
                                onClick={() => toggleDevice(device)}
                                className={`kanews-visibility-control__device-button ${value[device] !== false ? 'is-active' : ''}`}
                            />
                        </Tooltip>
                    ))}
                </div>
            </div>
            <div className="hidden-labels" style={{ display: 'none' }}>
                <div className="hidden-desktop" data-label={getHiddenLabel(DEVICE_TYPES.DESKTOP)}></div>
                <div className="hidden-tablet" data-label={getHiddenLabel(DEVICE_TYPES.TABLET)}></div>
                <div className="hidden-mobile" data-label={getHiddenLabel(DEVICE_TYPES.MOBILE)}></div>
            </div>
        </BaseControl>
    );
};

export default VisibilityControl; 